import { twMerge } from 'tailwind-merge';

const sizes = {
  s: 'text-base2',
  l: 'text-lg',
};

interface Props {
  size?: keyof typeof sizes;
  className?: string;
}

export function Chevron({ size = 's', className }: Props) {
  return (
    <span
      className={twMerge(
        `w-5 h-5 inline-flex items-center justify-center ${sizes[size]}`,
        className,
      )}
    >
      ›
    </span>
  );
}
